
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Punetosadeteenshaktipeethbus() {



    const cardData =
    {
        keyword: 'Pune Sade Teen Shakti Peeth Bus on Rent',
        heading: 'Amruta Travels: Pune Sade Teen Shakti Peeth Bus on Rent',
        headingDescription: 'Amruta Travels offers Pune Sade Teen Shakti Peeth Bus on Rent, making your spiritual journey to the revered Shakti Peethas comfortable and hassle-free. Whether you are planning a pilgrimage with family, friends, or a group tour, we provide clean and well-maintained buses that ensure a smooth and devotional travel experience. Our fleet includes 17-seater, 32-seater, and 50-seater buses, driven by experienced and courteous drivers familiar with the sacred routes. With punctual service, budget-friendly packages, and 24/7 support, Amruta Travels makes your Pune Sade Teen Shakti Peeth Darshan peaceful, safe, and memorable. Book your spiritual tour with us today!',


        top: 'Top Places to Visit in Sade Teen Shakti Peeth with Amruta Travels',
"topPlaces": [
  {
    "title": "Mahalakshmi Temple, Kolhapur",
    "description": "Also known as Ambabai Temple, this ancient shrine is dedicated to Goddess Mahalakshmi. It is considered one of the 18 Maha Shakti Peethas, where it is believed that the eyes of Goddess Sati fell. The temple is a major pilgrimage site, attracting devotees from across India."
  },
  {
    "title": "Tulja Bhavani Temple, Tuljapur",
    "description": "Located in Tuljapur, this temple is dedicated to Goddess Bhavani, an incarnation of Durga. It holds immense significance as the family deity of Chhatrapati Shivaji Maharaj, who is believed to have received his sword from the goddess here."
  },
  {
    "title": "Renuka Devi Temple, Mahur",
    "description": "Situated in Mahur, Nanded district, this temple honors Goddess Renuka, the mother of Lord Parashurama. It is one of the complete Shakti Peethas and is considered a sacred site for devotees seeking blessings of the divine mother."
  },
  {
    "title": "Saptashrungi Temple, Vani",
    "description": "Perched on the Saptashrungi hills near Nashik, this temple is dedicated to Goddess Saptashrungi Nivasini. It is regarded as a half Shakti Peeth, making up the 'half' in the 'Three and a Half Shakti Peethas'. The temple is known for its scenic location and spiritual significance."
  }
],



    "services": [
    {
      "name": "Sade Teen Shakti Peeth Yatra from Pune",
      "description": "Amruta Travels organizes devotional Sade Teen Shakti Peeth Yatra packages from Pune covering Tuljapur, Kolhapur (Mahalaxmi), Mahurgad (Renuka Mata), and Vani (Saptashrungi). Our AC and Non-AC buses with experienced drivers ensure a spiritually fulfilling and safe pilgrimage for all age groups."
    },
    {
      "name": "Pune to Mahalaxmi Temple at Kolhapur Bus Hire",
      "description": "Plan a peaceful trip to Kolhapur’s Mahalaxmi Temple with Amruta Travels’ bus rental service. Ideal for family pilgrimages and group tours, we offer clean and well-maintained AC/Non-AC buses with reliable chauffeurs to ensure a smooth journey."
    },
    {
      "name": "Pune to Tuljapur Tempo Traveller on Rent",
      "description": "Visit the revered Tulja Bhavani Temple in Tuljapur with Amruta Travels’ Tempo Traveller rental. Choose from 14 to 20-seater AC options perfect for small groups or families seeking a comfortable darshan experience."
    },
    {
      "name": "Pune to Renuka Mata at Mahurgad Bus on Rent",
      "description": "Amruta Travels provides rental buses from Pune to Renuka Mata Mandir in Mahurgad. With AC options, spacious seating, and experienced drivers, your pilgrimage becomes serene and hassle-free."
    },
    {
      "name": "Pune to Mahurgad Bus on Rent Package",
      "description": "Book a dedicated Mahurgad trip package from Pune with Amruta Travels. Our itinerary includes temple visits, smooth travel arrangements in AC buses, and experienced support throughout your spiritual journey."
    },
    {
      "name": "Pune to Saptashrungi Mata Vani Bus on Rent",
      "description": "Travel from Pune to Saptashrungi Mata Temple in Vani in our clean and comfortable buses. Suitable for small to large groups, this service includes driver assistance, punctual departures, and safe transport for pilgrims."
    },
    {
      "name": "Bus Hire for 3.5 Shakti Peeth Yatra from Pune",
      "description": "Experience Maharashtra’s sacred Shakti Peethas with Amruta Travels’ complete 3.5 Peeth Yatra package from Pune. Our AC buses with reclining seats and professional service ensure you focus on devotion while we handle the logistics."
    },
    {
      "name": "Mini Bus on Rent for Sade Teen Shakti Peeth Yatra",
      "description": "Amruta Travels offers 14 to 25-seater mini buses for the Sade Teen Shakti Peeth pilgrimage. These buses are ideal for small family groups or spiritual circles traveling across the divine destinations of Maharashtra."
    },
    {
      "name": "14 17 20 25 Seater Bus for Pune to Sade Teen Shakti Peeth Yatra",
      "description": "Choose from a fleet of mid-size AC buses for your Shakti Peeth Yatra. With comfortable interiors and experienced drivers, Amruta Travels ensures a pleasant and memorable religious tour experience for groups of all sizes."
    },
    {
      "name": "35 40 45 50 Seater Bus for Pune to Sade Teen Shakti Peeth Yatra",
      "description": "For larger groups and samuhik yatras, Amruta Travels offers full-size buses from Pune for the Sade Teen Shakti Peeth Yatra. With safety features, ample luggage space, and AC comfort, our fleet guarantees a worry-free darshan tour."
    },
    {
      "name": "3.5 Shakti Peethas Darshan in Maharashtra",
      "description": "Explore the holy 3.5 Shakti Peethas of Maharashtra—Tuljapur, Kolhapur, Mahurgad, and Saptashrungi—with Amruta Travels. Our guided bus packages are crafted for religious groups, offering peaceful travel and spiritually focused itineraries."
    }
  ],
  "tableData": [
    ["Sade Teen Shakti Peeth Yatra from Pune", "Pune to Mahalaxmi Temple at Kolhapur Bus Hire"],
    ["Pune to Tuljapur Tempo Traveller on Rent", "Pune to Renuka Mata at Mahurgad Bus on Rent"],
    ["Pune to Mahurgad Bus on Rent Package", "Pune to Saptashrungi Mata Vani Bus on Rent"],
    ["Bus Hire for 3.5 Shakti Peeth Yatra from Pune", "Mini Bus on Rent for Sade Teen Shakti Peeth Yatra"],
    ["14 17 20 25 Seater Bus for Pune to Sade Teen Shakti Peeth Yatra", "35 40 45 50 Seater Bus for Pune to Sade Teen Shakti Peeth Yatra"],
    ["3.5 Shakti Peethas Darshan in Maharashtra", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Spiritual Journey to Sade Teen Shakti Peeth from Pune",
    "WhyChoosedescription": "Amruta Travels offers comfortable and reliable Pune Sade Teen Shakti Peeth Bus on Rent services, perfect for religious tours and group pilgrimages. Visit the sacred Shakti Peeths—Mahalaxmi (Kolhapur), Tulja Bhavani (Tuljapur), Renuka Mata (Mahur), and Saptashrungi (Vani) with ease and devotion. Our buses provide a peaceful and spiritually uplifting journey through these important pilgrimage destinations."
  },
  {
    "WhyChooseheading": "Ideal for Devotee Groups, Temple Committees, and Family Pilgrimages",
    "WhyChoosedescription": "Our Sade Teen Shakti Peeth bus rental is designed to serve all types of spiritual travelers—whether it's a temple group, senior citizen group, religious tour operator, or a large family pilgrimage. With bus options ranging from 32 to 50 seaters, we accommodate all group sizes comfortably, ensuring everyone can travel together on this divine route."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Knowledge of Pilgrimage Routes",
    "WhyChoosedescription": "Our professional drivers are well-versed with all routes connecting Pune to the Sade Teen Shakti Peeth temples. They ensure safe, punctual, and smooth travel while respecting the devotional nature of the trip. With courteous behavior and familiarity with rest stops and dhabas, your group can focus on the spiritual experience while we manage the logistics."
  },
  {
    "WhyChooseheading": "Well-Maintained, Clean, and Comfortable Buses",
    "WhyChoosedescription": "Our buses are thoroughly cleaned and well-maintained to ensure a hygienic and comfortable journey, especially for long routes covering multiple Shakti Peeths. With cushioned seating, ample legroom, and air conditioning (or non-AC options), we make sure every devotee enjoys a comfortable spiritual trip across Maharashtra."
  },
  {
    "WhyChooseheading": "Flexible Itineraries and Multi-Day Tour Packages",
    "WhyChoosedescription": "The Sade Teen Shakti Peeth Yatra often spans multiple days. We provide fully customizable itineraries that include travel planning, night halts, meal stops, and temple timings. Our team helps you design the ideal route so your group can visit all temples in a structured and convenient manner without any time pressure."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "We offer budget-friendly pricing for Pune Sade Teen Shakti Peeth Bus on Rent. With transparent billing and no hidden charges, your group can plan a spiritually rewarding trip without financial stress. Whether it’s a single-day trip or a 3–4 day tour, we provide clear, upfront rates to suit your group size and trip duration."
  },
  {
    "WhyChooseheading": "Pickup and Drop-off from Any Point in Pune",
    "WhyChoosedescription": "We offer flexible pickup and drop-off options anywhere in Pune—be it your home, society, temple, or office. This convenience ensures your group starts the pilgrimage together and returns comfortably. We also provide coordination support for large groups to help manage timely departures and arrivals."
  },
  {
    "WhyChooseheading": "Easy Booking with Devoted Customer Support",
    "WhyChoosedescription": "Booking your Sade Teen Shakti Peeth Yatra bus with Amruta Travels is quick and hassle-free. You can book online, over the phone, or by visiting our office. Our dedicated team is here to assist you with vehicle selection, itinerary customization, and any queries related to temple routes, halts, and lodging suggestions."
  }
]

















    }

const faqData = [
  {
    question: 'How can I rent a bus for visiting the Sade Teen Shakti Peeth from Pune?',
    answer: 'You can easily rent a bus with Amruta Travels for the Sade Teen Shakti Peeth Yatra starting from Pune. Just call us, book online, or visit our office, and we’ll arrange a suitable bus based on your group size and itinerary.',
  },
  {
    question: 'Which temples are covered in the Sade Teen Shakti Peeth Yatra from Pune?',
    answer: 'The Sade Teen Shakti Peeth Yatra typically includes visits to three and a half Shakti Peeth temples: Mahalakshmi (Kolhapur), Tulja Bhavani (Tuljapur), Renuka Mata (Mahur), and Saptashrungi (considered as half) near Nashik.',
  },
  {
    question: 'What types of buses are available for this pilgrimage?',
    answer: 'We offer 32, 35, 40, 45, and 50-seater buses in both standard and luxury variants. Our buses are equipped with air conditioning, push-back seats, and sufficient luggage space—ideal for long journeys.',
  },
  {
    question: 'Is the bus suitable for elderly pilgrims and families?',
    answer: 'Yes, our buses are perfect for family groups and senior citizens. We ensure a smooth and safe journey with comfortable seating and experienced drivers familiar with religious routes.',
  },
  {
    question: 'How many days does the Sade Teen Shakti Peeth tour take?',
    answer: 'The full circuit typically takes 3 to 4 days depending on the time spent at each temple and the pace of travel. We can customize the tour schedule to meet your group’s needs.',
  },
  {
    question: 'Can we book the bus for a private group yatra?',
    answer: 'Absolutely. We provide private group bookings so your travel remains exclusive and comfortable. Share your plan with us and we’ll handle the logistics.',
  },
  {
    question: 'How much does it cost to rent a bus for the Sade Teen Shakti Peeth Yatra?',
    answer: 'The cost depends on the bus size, duration of the trip, and travel route. Contact us with your itinerary for a personalized quote with transparent pricing.',
  },
  {
    question: 'Are your buses well-maintained and sanitized?',
    answer: 'Yes, all our buses are regularly serviced and thoroughly sanitized before each trip to ensure hygiene and passenger safety throughout the journey.',
  },
  {
    question: 'Why choose Amruta Travels for the Shakti Peeth Yatra from Pune?',
    answer: 'Amruta Travels specializes in religious group tours. Our reliable service, experienced drivers, comfortable buses, and attention to detail make us a preferred choice for pilgrimage travel from Pune.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mrs. Vaishali Patil',
    role: 'Pilgrimage Group Leader, Pune',
    text: 'We booked a 45-seater bus for our Sade Teen Shakti Peeth Yatra from Pune. The bus was comfortable, clean, and perfectly suited for the long journey. The driver was very polite and cooperative. Excellent service by Amruta Travels!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mr. Anil Bhosale',
    role: 'Devotee, Pune',
    text: 'Our family group visited all Shakti Peeths from Pune using a 35-seater bus from Amruta Travels. The experience was peaceful and well-managed. I highly recommend them for religious tours.',
    rating: 5,
  },
];




















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Sade Teen Shakti Peeth Bus on Rent",
  "image": "https://bushireinpune.com/assets/images/sade-teen-shakti-peeth-bus-on-rent.jpg",
  "description": "Book buses for the Sade Teen Shakti Peeth Yatra from Pune covering Tuljapur, Mahurgad (Renuka Mata), Kolhapur (Mahalaxmi Temple), and Saptashrungi Mata. Available options: 14, 17, 20, 25, 35, 40, 45, and 50 seater buses. Ideal for group darshan, religious yatras, and spiritual tours across Maharashtra.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "16105"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4799",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/pune-sade-teen-shakti-peeth-bus-on-rent"
  }
};





    return (
        <div>
<Helmet>
  <title>Call: +91 7353109555 | Pune Sade Teen Shakti Peeth Bus on Rent | 3.5 Shakti Peeth Yatra | Amruta Travels</title>
  <meta 
    name="description" 
    content="Hire buses from Pune for Sade Teen Shakti Peeth Yatra covering Kolhapur, Tuljapur, Mahurgad & Saptashrungi. 14 to 50 seater bus options for religious group travel in Maharashtra." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/39.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetosadeteenshaktipeethbus;